export default __webpack_public_path__ + "static/media/avatarC7.fdb765da.png";